"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));

var _reactRedux = require("react-redux");

var _Typography = _interopRequireDefault(require("vf-comps/build/components/protons/typography/Typography"));

var _ButtonDefault = _interopRequireDefault(require("vf-comps/build/components/atoms/buttons/button/ButtonDefault"));

var _BoxSizing = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxSizing/BoxSizing"));

var _BoxStyled = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxStyled/BoxStyled"));

var _GridContainer = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridItem"));

var _HiFiIcon = _interopRequireDefault(require("vf-comps/build/components/protons/icons/HiFiIcon"));

var _DialogDefault = _interopRequireDefault(require("vf-comps/build/components/organisms/dialog/DialogDefault/DialogDefault"));

var _searchActions = require("../actions/searchActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TimeOutError = function TimeOutError(_ref) {
  var open = _ref.open;
  var t = (0, _useTranslation.default)();
  var theme = (0, _core.useTheme)();
  var isSmall = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'));

  var _useState = (0, _react.useState)(open),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setCloseValue = _useState2[1];

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _searchActions.sendTags)({
      taggingId: 'CUSTOMER_SEARCH_WIDGET_4',
      taggingType: 'link',
      taggingValue: {
        page_error: t('popupMsg')
      }
    }));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_DialogDefault.default, {
    openDialog: value,
    title: "",
    closeAction: function closeAction() {
      setCloseValue(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    mt: isSmall ? 'xxl' : 'none',
    mb: isSmall ? 'small' : 'nSmall'
  }, /*#__PURE__*/_react.default.createElement(_HiFiIcon.default, {
    icon: "ic_warning",
    size: "xlarge"
  }))), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "VfGrey",
    bold: true,
    regular: true,
    variant: "h4",
    text: "".concat(t('somethingWrong')),
    align: "center",
    "data-testid": "somethingWrong"
  })), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "VfGrey",
    regular: true,
    variant: "body",
    text: "".concat(t('popupMsg')),
    align: "center",
    "data-testid": "popupMsg-text"
  })), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_BoxStyled.default, {
    className: {
      minWidth: '328px',
      marginBottom: !isSmall ? '52px' : '',
      marginTop: !isSmall ? '24px' : '',
      position: isSmall ? 'absolute' : '',
      left: '16px',
      right: '16px',
      margin: isSmall ? 'auto' : '',
      bottom: '52px'
    }
  }, /*#__PURE__*/_react.default.createElement(_ButtonDefault.default, {
    fullWidth: true,
    variant: "primary",
    action: function action() {
      return setCloseValue(false);
    },
    title: "".concat(t('tryAgain'))
  })))));
};

var mapDispatchToProps = {};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TimeOutError);

exports.default = _default;